import {Text} from 'src/v2/components/common';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useSelector} from 'src/v2/state/store';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  disclaimer: {
    id: 'crypto.payins.v2.transaction_processing_time_disclaimer.disclaimer_message',
    description:
      'Dislaimer shown when transaction is processing and may take some time to complete.',
    defaultMessage:
      "It may take up to a minute to complete this transaction. You will be redirected back to {merchant} when it's complete.",
  },
});

export const TransactionProcessingTimeDisclaimer = () => {
  const businessName = useSelector(
    (state) => state.merchantBranding.businessName,
  );

  return (
    <Text
      type="caption"
      css={{textAlign: 'center', color: COLORS.textSubduedOnLight}}
    >
      <FormattedMessage
        {...messages.disclaimer}
        values={{
          merchant: businessName,
        }}
      />
    </Text>
  );
};
